<template>
<div class="participant-profile-card" :class="[{'no-picture': pictureBackgroundImage === ''}, {'have-picture': pictureBackgroundImage !== ''}, pictureCircleColorClass]">
  <div class="top">
    <div class="picture-wrap" :class="pictureCircleColorClass">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <filter id="blur">
              <feGaussianBlur stdDeviation="15" />
          </filter>
      </svg>
      <!-- <img :src="pictureUrl" class="blur"> -->
      <div class="full-picture blur" :style="pictureBackgroundImage"></div>
      <i :class="['full-icon', participantIconClass, pictureCircleColorClass]"></i>
      <div class="picture-circle" :class="[pictureCircleColorClass, { 'have-image': pictureUrl !== '' }]">
        <div class="picture" :style="pictureBackgroundImage"></div>
        <i :class="participantIconClass"></i>
      </div>
    </div>
    <div class="picture-text" :class="pictureCircleColorClass">
      <p class="name">{{ participantDetails.full_name }}</p>
      <p class="email">{{ participantDetails.gender }}, {{ participantDetails.age }} years old</p>
    </div>
  </div>
  <!-- <hr> -->
</div>
</template>

<script>
export default {
  name: 'participant-profile-card',
  props: {
    participantDetails: {
      type: Object,
      required: true,
      default: null,
    },
  },
  computed: {
    pictureCircleColorClass() {
      return (this.participantDetails && this.participantDetails.gender === 'female') ? 'is-female' : 'is-male';
    },
    participantIconClass() {
      return (this.participantDetails && this.participantDetails.gender === 'female') ? 'icon-ca-user-female' : 'icon-ca-user-male';
    },
    pictureBackgroundImage() {
      return this.participantDetails.ProfilePicture ? `backgroundImage: url(${process.env.IMAGES_ROOT}${this.participantDetails.ProfilePicture.path}${this.participantDetails.ProfilePicture.thumbnails.large.filename})` : '';
    },
    pictureUrl() {
      return this.participantDetails.ProfilePicture ? `${process.env.IMAGES_ROOT}${this.participantDetails.ProfilePicture.path}${this.participantDetails.ProfilePicture.thumbnails.large.filename}` : '';
    },
  },
};
</script>

<style lang="scss">
@import "~styles/theme/colors";
@import "~styles/theme/person-colors";
@import '~styles/mixins/mixins';

.participant-profile-card {
  position: relative;

  .top {
    position: relative;
    text-align: center;
    overflow: hidden;
    width: 100%;
    height: 18em;

    // &:before {
    //   content: '';
    //   display: block;
    //   padding-top: 100%;
    // }

    .picture-wrap {
      display: flex;
      position: absolute;
      align-items: center;
      justify-content: center;
      top: 0; left: 0; bottom: 0; right: 0;

      svg {
        display: none;
      }

      .full-picture {
        width: 100%;
        height: 100%;
        position: absolute;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }

      // img {
      //   position: absolute;
      //   left: center; top: center;
      //   width: 100%;
      // }

      i.full-icon {
        font-size: 12rem;
        position: absolute;
        left: 0;
        line-height: 1.4em;
        transition: 0.5s;
        width: 100%;
        &.is-male  {
          color: $male-dark;
        }
        &.is-female {
          color: $female-dark;
        }
      }

      .blur {
        filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='0');
        filter: blur(0px);
      }

      .picture-circle {
        position: relative;
        border: 0.25em solid #fff;
        background-color: $beige;
        width: 10em;
        height: 10em;
        border-radius: 50%;
        overflow: hidden;
        z-index: 1;
        transition: 1s;
        opacity: 0;
        .picture {
          position: absolute;
          top: 0; left: 0;
          width: 100%;
          height: 100%;
          background-size: auto 100%;
          background-position: center center;
          background-repeat: no-repeat;
        }
        i {
          font-size: 8rem;
          line-height: 9rem;
        }
        &.is-male  {
          background-color: rgba($male-dark, 0.5);
          i {
            color: $male-darker;
          }
        }
        &.is-female {
          background-color: rgba($female-dark, 0.5);
          i {
            color: $female-darker;
          }
        }
      }
    }
  }

  .picture-text {
    margin: 0;
    z-index: 1;
    color: #fff;
    padding: 0.5em 00.75em;
    text-align: left;
    line-height: 1.15;
    position: absolute;
    bottom: 0; left: 0; right: 0;
    background-color: rgba(0,0,0,0.75);
    .name {
      font-size: 1.15em;
      font-weight: 800;
      text-shadow: 0 -1px 0 rgba(0,0,0,0.25);
    }
    &.is-male  {
      background-color: rgba($male-dark, 0.5);
    }
    &.is-female {
      background-color: rgba($female-dark, 0.5);
    }

  }

  hr {
    margin: 1rem 0 0;
  }

  &:hover {
    cursor: pointer;
    .top {
      .blur {
        position: absolute;
        top: 0; left: 0;
        filter: url(#blur);
        filter: blur(15px);
        filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='15');
        transition: 1s;
      }
      .full-icon {
        opacity: 0;
      }
      .picture-circle {
        opacity: 1;
      }
    }
  }

  &.have-picture {
    .top {
      .picture-wrap {
        .full-icon { display: none; }
      }
      .picture-circle {
        > i { display: none; }
      }
    }
  }

  &.no-picture.is-male {
    background-color: rgba($male-lighter, 0.5);
  }

  &.no-picture.is-female {
    background-color: rgba($female-lighter, 0.5);
  }

  &.no-picture:hover {
    .top {
      .picture-circle { opacity: 1; }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/components/ui/card/user-profile-card.vue